import { useRef, useCallback, useState } from "react";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";
import Loader from "../../../shared/ui/Loader.js";
import { useGlobalContext } from "../../../Config.js";
import useTiposDocumento from "../../../shared/hooks/useTiposDocumento.js";
import useConfiguracionDocumentos from "../hooks/useConfiguracionDocumentos.js";
import AgrupacionTable from "../components/AgrupacionTable.js";
import DialogReconfiguracionCliente from "../components/DialogReconfiguracionCliente.js";

const Agrupacion = () => {
  const { baseUrl } = useGlobalContext();
  const toast = useRef();
  const { tiposDocumento, loadingTipos } = useTiposDocumento(baseUrl);
  // Cliente seleccionado para reconfigurar sus documentos de venta
  const [clienteConfigurar, setClienteConfigurar] = useState(null);

  const handleMostrarError = useCallback(() => {
    toast.current?.show({
      severity: "error",
      summary: "Error",
      detail: "No se pudo cargar la configuración de documentos de venta",
      life: 3000,
    });
  }, []);

  const {
    clientesFiltrados,
    loading,
    busqueda,
    setBusqueda,
    expandedRows,
    setExpandedRows,
    toggleFila,
    recargar,
  } = useConfiguracionDocumentos(baseUrl, handleMostrarError);

  //---------------------------------
  // FORMATOS Y ESTILOS
  //---------------------------------
  const renderHeader = () => (
    <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center gap-2">
      <span className="p-input-icon-left w-full md:w-auto">
        <i className="pi pi-search" />
        <InputText
          value={busqueda}
          onChange={(e) => setBusqueda(e.target.value)}
          placeholder="Buscar por alias o producto"
          className="w-full md:w-auto"
        />
      </span>
      <span className="text-600">{clientesFiltrados?.length} clientes</span>
    </div>
  );

  //---------------------------------
  // RENDER
  //---------------------------------
  return (
    <div className="grid">
      <Toast ref={toast} />
      <div className="col-12">
        <div className="card">
          <h4>Agrupación Documentos de Venta</h4>
          <h6 className="mt-1 mb-3 text-600">
            Configuración de documentos de venta por cliente en
            asignaciones Vigentes y Futuras.
          </h6>
          {loading || loadingTipos ? (
            <Loader />
          ) : (
            <AgrupacionTable
              clientes={clientesFiltrados}
              loading={loading}
              catalogo={tiposDocumento}
              expandedRows={expandedRows}
              onRowToggle={(e) => setExpandedRows(e.data)}
              onRowClick={(e) => toggleFila(e.data)}
              onConfigurar={(cliente) => setClienteConfigurar(cliente)}
              header={renderHeader()}
            />
          )}
        </div>
      </div>

      <DialogReconfiguracionCliente
        visible={!!clienteConfigurar}
        cliente={clienteConfigurar}
        catalogo={tiposDocumento}
        onHide={() => setClienteConfigurar(null)}
        onGuardado={() => {
          setClienteConfigurar(null);
          recargar();
          toast.current?.show({
            severity: "success",
            summary: "Éxito",
            detail: "Configuración de documentos de venta guardada",
            life: 3000,
          });
        }}
      />
    </div>
  );
};

export default Agrupacion;
